import React, { useEffect, useState } from "react";
import { Card, Form, Button, Alert, Row, Col, Spinner } from "@themesberg/react-bootstrap";
import api from "../../utils/api";

export default () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const load = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await api.get("/auto-msg/settings");
      setSettings(res.data?.settings || {});
    } catch (e) {
      setError(e.response?.data?.error || e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      setSaving(true);
      setError(null);
      const res = await api.put("/auto-msg/settings", settings);
      setSettings(res.data.settings);
      setSuccess("Ayarlar kaydedildi.");
      setTimeout(() => setSuccess(null), 2500);
    } catch (e) {
      setError(e.response?.data?.error || e.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  const fields = [
    { key: "firstMessageDelayMin", label: "İlk mesaj süresi (dk)", help: "Kayıt sonrası ilk fake mesajı için bekleme" },
    { key: "interFakeDelayMin", label: "Fake hesaplar arası bekleme (dk)", help: "Bir fake ilk mesajını attıktan sonra sıradaki fake başlar (önceki zincir bitmeden paralel devam eder)" },
    { key: "secondMessageDelayMin", label: "2. mesaj süresi (dk)", help: "İlk mesajdan sonra cevap yoksa" },
    { key: "thirdMessageDelayMin", label: "3. mesaj süresi (dk)", help: "İkinci mesajdan sonra cevap yoksa" },
    { key: "subsequentMessageDelayMin", label: "Sonraki mesajlar (dk)", help: "4. mesaj ve sonrası için (varsayılan 480 = 8 saat); aynı fake içinde" }
  ];

  return (
    <div className="py-4">
      <h4 className="mb-1">Otomatik Mesaj Ayarları</h4>
      <p className="text-muted mb-4">Yeni üye mesaj zinciri süreleri ve sistem aç/kapa.</p>

      {error && <Alert variant="danger" onClose={() => setError(null)} dismissible>{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}

      <Card border="light" className="shadow-sm">
        <Card.Body>
          <Form.Check
            type="switch"
            id="auto-msg-enabled"
            label="Otomatik mesaj sistemi aktif"
            checked={!!settings?.enabled}
            onChange={(e) => setSettings({ ...settings, enabled: e.target.checked })}
            className="mb-4"
          />

          <Row>
            {fields.map((f) => (
              <Col md={6} key={f.key} className="mb-3">
                <Form.Label>{f.label}</Form.Label>
                <Form.Control
                  type="number"
                  min={0}
                  value={settings?.[f.key] ?? ""}
                  onChange={(e) => setSettings({ ...settings, [f.key]: Number(e.target.value) })}
                />
                <Form.Text className="text-muted">{f.help}</Form.Text>
              </Col>
            ))}
          </Row>

          <Button variant="primary" onClick={save} disabled={saving}>
            {saving ? "Kaydediliyor..." : "Kaydet"}
          </Button>
        </Card.Body>
      </Card>

      <Alert variant="warning" className="mt-3 mb-0">
        Eski Uygulama Ayarları → “İlk Mesaj” sekmesi bu sistemin yerini almaz.
        Yeni üye akışı yalnızca bu sayfadaki ayarlarla çalışır.
      </Alert>
    </div>
  );
};
